import { render, staticRenderFns } from "./PromotedProjects.vue?vue&type=template&id=5245a176&scoped=true"
import script from "./PromotedProjects.vue?vue&type=script&lang=js"
export * from "./PromotedProjects.vue?vue&type=script&lang=js"
import style0 from "./PromotedProjects.vue?vue&type=style&index=0&id=5245a176&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5245a176",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5245a176')) {
      api.createRecord('5245a176', component.options)
    } else {
      api.reload('5245a176', component.options)
    }
    module.hot.accept("./PromotedProjects.vue?vue&type=template&id=5245a176&scoped=true", function () {
      api.rerender('5245a176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/pages/home/components/PromotedProjects.vue"
export default component.exports